export default __webpack_public_path__ + "static/media/wa-blue-icon.7a4588ee.svg";